import { Injectable } from '@angular/core';

@Injectable()
export class UserService {

  private TEST2: string;
  /**
   * @description test
   */
  public test(): string {
    return 'test';
  }
  /**
   * @description guardar test2
   */
  set test2(value: string) {
    this.TEST2 = value;
  }
  /**
   * @description recuperar test2
   */
  get testOther2(): string {
    return this.TEST2;
  }
}
